import React from 'react'
import { Link } from 'gatsby'

const SportsPassListItem = ({ postIndex, postItem }) => {
	// Validation des props
	if (!postItem || typeof postItem !== 'object') {
		return null
	}
	
	const { num, objectid, equipement, image_, activite, jour, creneau, heures, type_sport, sport_pass, age } = postItem
	
	// Vérification des données requises
	if (!num || !activite) {
		return null
	}
	
	// Nettoyage et validation de l'activité
	if (typeof activite !== 'string' || activite.trim().length === 0) {
		return null
	}
	
	let activite_ref = activite.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, '').replace(/ /g, '-').replace(/[^\w-]+/g, '');
	activite_ref = activite_ref.trim() + '-' + objectid;

	return (
		<li className="sports-pass-list-item" key={postIndex}>
			<Link className="" to={`/services-infos-pratiques/sports/annuaire-sport-pass/${activite_ref}`}>
				<div className="sports-pass-list-item-content">
					<div className="sports-pass-list-item-content-picture" >
						{image_ && <img alt={equipement || ''} src={image_} />}
						<div className="sports-pass-list-item-content-picture-infos" >
							{jour && <p className="sports-pass-list-item-content-day"><span>{jour}</span></p>}
							{creneau && (creneau.toLowerCase() === "complet") && <p className="sports-pass-list-item-content-creneau">{creneau}</p>}
						</div>
					</div>
					<div className="sports-pass-list-item-content-info">
						{heures && <p className="sports-pass-list-item-content-heures">{heures}</p>}
						<h2 className="sports-pass-list-item-content-title" >{activite}{equipement && <><br />{equipement}</>}</h2>
						{type_sport && <p className="sports-pass-list-item-content-sport-pass">{type_sport}</p>}
						{sport_pass && age && <p className="sports-pass-list-item-content-sport-pass">{sport_pass} | {age}</p>}
					</div>
				</div>
			</Link>
		</li>
	)
}

export default SportsPassListItem
